import React from 'react';
import { buildUrl, VALID_URLS } from 'Douleutaras/utilities/url-builder';

import './CategoryLink.scss';

export interface CategoryLinkProps {
  id: string;
  title: string;
  /** Category's main bsdir page, absent when admin has mapped none — then we keep the redirecting URL. */
  mainLandingUrl?: string;
}

export const CategoryLink = ({ id, title, mainLandingUrl }: CategoryLinkProps) => (
  <li styleName="related-services__item">
    <a href={mainLandingUrl || buildUrl(VALID_URLS.CATEGORY, id)} styleName="related-services__link">{title}</a>
  </li>
);

export default CategoryLink;
